/* eslint-disable */
import { observable, action, toJS } from 'mobx'
import axios from 'axios'
import qs from 'qs'
import _window from 'window-or-global'

import cookie from '../utils/cookie'
import authCookie from '../utils/authCookie'

import config from '../config'

import autoStore from './autoStore'

class Auth {
  constructor() {
    this.response = {}
    this.token = {}

    autoStore('auth', this)
  }

  @observable
  response = {
    login: null,
    register: null,
    remind: null,
    reset: null
  }

  @observable
  token = {
    pending: false
  }

  @action
  refresh = () => {
    if (!this.token.refreshToken) {
      this.response.login = {}
      this.token = {
        pending: true
      }

      return Promise.reject(new Error('Not sign in'))
    }

    return this.getToken({
      grant_type: 'refresh_token',
      refresh_token: this.token.refreshToken
    })
      .then(res => {
        this.token = {
          ...this.token,
          ...res.data,
          pending: false
        }

        this.updateCookie()
      })
      .catch(e => {
        console.warn(e)
        this.token = {
          pending: false
        }
      })
  }

  @action
  login = data => {
    if (!data.password || !data.email) {
      this.response.login = {
        statusCode: 400,
        data: {
          message: 'Email and password fields are required.'
        }
      }

      return Promise.reject(new Error(this.response.login.data))
    }

    this.token = {
      codeChallenge: Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 5)
    }

    return this.authorise({
      client_id: config.client_id,
      auth_type: 'email',
      auth_email: data.email,
      auth_password: data.password,
      response_type: 'code',
      code_challenge: this.token.codeChallenge,
      code_challenge_method: 'plain',
      state: this.token.codeChallenge,
      scope:
        'user_support user_communities_support user_view user_update user_communities_view user_communities_update user_communities_stats user_communities_transactions'
    })
      .then(res => res.data)
      .then(res =>
        this.getToken({
          grant_type: 'authorization_code',
          code: res.authorizationCode
        })
      )
      .then(res => {
        this.token = {
          ...this.token,
          ...res.data,
          pending: false
        }
        this.updateCookie()
      })
      .catch(e => {
        console.warn(e)
        this.response = {
          ...this.response,
          login: {
            statusCode: e.response.status,
            data: e.response.data
          }
        }
      })
  }

  @action
  logout = () => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/oauth2/revoke`,
      data: qs.stringify({
        access_token: this.token.accessToken
      })
    })
      .then(() => {
        this.token = {
          pending: false
        }
        Object.keys(this.response).forEach(k => (this.response[k] = {}))
        cookie.removeCookie('token')
      })
      .catch(() => {
        this.token = {
          pending: false
        }
        Object.keys(this.response).forEach(k => (this.response[k] = {}))
        cookie.removeCookie('token')
      })
  }

  @action
  authorise = data => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/oauth2/authorise`,
      data
    })
  }

  @action
  getToken = data => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/oauth2/token`,
      data: qs.stringify({
        client_id: config.client_id,
        code_verifier: this.token.codeChallenge,
        grant_type: data.grant_type,
        ...(data.code
          ? { code: data.code }
          : data.refresh_token ? { refresh_token: data.refresh_token } : {})
      })
    })
  }

  @action
  remind = data => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/passport/password/remind`,
      data
    })
      .then(res => {
        this.response = {
          ...this.response,
          remind: {
            statusCode: res.status,
            data: res.data
          }
        }
      })
      .catch(e => {
        this.response = {
          ...this.response,
          remind: {
            statusCode: e.response.status,
            data: e.response.data
          }
        }
      })
  }

  @action
  reset = data => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/passport/password/reset`,
      data
    })
      .then(res => {
        this.response = {
          ...this.response,
          reset: {
            statusCode: res.status,
            data: res.data
          }
        }
      })
      .catch(e => {
        console.warn(e)
        this.response = {
          ...this.response,
          reset: {
            statusCode: e.response.status,
            data: e.response.data
          }
        }
      })
  }

  @action
  signup = data => {
    if (!data.email) {
      this.response.register = {
        statusCode: 400,
        data: {
          message: 'Email field is required.'
        }
      }

      return Promise.reject(new Error(this.response.register.data))
    }

    return axios({
      method: 'post',
      url: `${config.api_uri}/passport/signup`,
      data
    })
      .then(res => {
        this.response.register = {
          statusCode: res.status,
          data: res.data
        }

        return this.response.register
      })
      .catch(e => {
        this.response.register = {
          statusCode: e.response.status,
          data: e.response.data
        }

        return this.response.register
      })
  }

  updateCookie = () => {
    cookie.setCookie('token', authCookie.stringify(toJS(this.token)))
  }
}

const AuthStore = (_window.AuthStore = new Auth())
export default AuthStore



// WEBPACK FOOTER //
// ./src/stores/Auth.js